export const colorScheme = 'light';
